import { Link } from "react-router-dom";
import { MessageSquare } from "lucide-react";

import { useLanguage } from "@/lib/i18n/LanguageContext";
import {
  useIssueOriginThreadQuery,
  useThreadScopeQuery,
} from "@/stores/documents/comments/queries";

/**
 * "Created from a comment on plan.pdf (page 4)" — shown on an issue that was
 * filed from a document comment thread, linking back to that thread. Renders
 * nothing for every other issue.
 */
export function IssueOriginLine({ issueId, buildingId }: { issueId: number; buildingId: number }) {
  const { t } = useLanguage();
  const origin = useIssueOriginThreadQuery(issueId);
  const thread = origin.data ?? null;
  const scope = useThreadScopeQuery(thread?.documentId ?? null);
  if (!thread) return null;
  const c = t.documents.comments;
  const filename = scope.data?.filename ?? "…";
  const text =
    thread.pageNumber != null
      ? c.originPage.replace("{filename}", filename).replace("{page}", String(thread.pageNumber))
      : c.origin.replace("{filename}", filename);
  return (
    <Link
      to={`/buildings/${buildingId}/documents?comments=${thread.id}`}
      className="inline-flex min-w-0 items-center gap-1 text-[11px] text-muted-foreground hover:text-foreground hover:underline"
      title={text}
    >
      <MessageSquare className="h-3 w-3 shrink-0" />
      <span className="truncate">{text}</span>
    </Link>
  );
}
